import { Component, OnInit } from "@angular/core";
import { HttpParams, HttpHeaders, HttpClient } from "@angular/common/http";
import { ApiCallingService } from "../../services/api-calling.service";

import { ConfigApi } from "../../config-api";
import { NgForm } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { Globals } from "../../common/global";
import { DomSanitizer } from "@angular/platform-browser";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CsvService } from "../../services/csv.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-review",
  templateUrl: "./review.component.html",
  styleUrls: ["./review.component.css"],
})
export class CustomerReviewComponent implements OnInit {
  today: any = moment(new Date()).format("YYYY-MM-DD");
  startday: any;
  endday: any;
  show = true;
  showSecond = false;
  modeltitle: any;
  page = 1;
  pageSize = 10;
  data = [];
  totalcount = 0;
  detail: any;
  status: any;
  type: string = "reviews";

  constructor(
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private apiCallingService: ApiCallingService,
    public Globals: Globals,
    public http: HttpClient,
    public datepipe: DatePipe,
    private CsvService: CsvService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getList();
  }
  getList() {
    let page = this.page == 0 ? 0 : this.page - 1;
    let OpId = this.Globals.getUser()._id;
    let query =
      "?type=" +
      this.type +
      "&operator_id=" +
      OpId +
      "&page=" +
      page +
      "&limit=" +
      this.pageSize;

    this.apiCallingService
      .callAPI({}, "GET", ConfigApi.URLS.CUSTOMER_REVIEW + query)
      .subscribe((res) => {
        this.data = res.data;
        this.totalcount = res.total;
      });
  }

  loadPage(page: number) {
    if (page) {
      this.page = page;
      this.getList();
    }
  }
  loadPageForReview(type: string) {
    if (type) {
      this.type = type;
      this.getList();
    }
  }

  openModal(targetModal: NgbModal, data: any, title: any) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
    this.status =
      this.detail.status == "" || this.detail.status == undefined
        ? "publish"
        : this.detail.status;
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }
  downloadCSV(type: string) {
    let operatorId = this.Globals.getUser()._id;
    let query = "?type=" + type + "&operator_id=" + operatorId;

    const url =
      type == "reviews"
        ? ConfigApi.URLS.CUSTOMER_REVIEW_CSV + query
        : ConfigApi.URLS.CUSTOMER_RATING_CSV + query;

    this.apiCallingService.callAPI({}, "GET", url).subscribe((res) => {
      let csvData = res.data;
      this.downloadFile(csvData, type);
    });
  }
  private downloadFile(data: any, type: string) {
    const receiptData = data || [];
    const finalCsvData: any[] = [];

    receiptData.forEach((d: any, index: number) => {
      const csvEntry = {
        "Created Date": this.datepipe.transform(d?.created_at, "yyyy-MM-dd"),
        UserName: d?.user_id?.username || "-",
        "Email ID": d?.user_id?.email || "-",
        Mobile: d?.user_id?.mobile || "-",
        "User Address": d?.user_id?.address || "-",
        "Average Rating": d?.avg_rating || "-",
        "Brand Name": d?.brand_name || "-",
        Comment: d?.comment || "-",
      };

      finalCsvData.push(csvEntry);
    });

    this.CsvService.downloadRatingFile(
      finalCsvData,
      type === "reviews" ? "Customer Review" : "Customer Rating"
    );
    this.toastr.success("CSV exported successfully");
  }
  onSubmit(f: any) {
    const body = new HttpParams()
      .set("operator_reply", f.value.operator_reply)
      .set("status", this.status);
    this.apiCallingService
      .callAPI(
        body,
        "POST",
        ConfigApi.URLS.UPDATE_CUSTOMER_REPLY_OPRATOR + "/" + this.detail._id
      )
      .subscribe((res) => {
        this.getList();
        this.modalService.dismissAll();
      });
  }
  changeStatus() {
    const body = new HttpParams().set("status", this.status);
    this.apiCallingService
      .callAPI(
        body,
        "POST",
        ConfigApi.URLS.UPDATE_CUSTOMER_REPLY_OPRATOR + "/" + this.detail._id
      )
      .subscribe((res) => {});
  }
}
